// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__RmjD0","title":"FrontImage_title__2JyVP"};